import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { color, space } from 'styled-system';

export const HeaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  margin-bottom: 20px;
  ${space};
background-color: white;
width:100%;
  h1 {
    color: ${props => props.theme.colors.white};
    margin: 0;
    font-size: 24px;
    font-weight: normal;
    ${props => props.theme.media.tablet`
      font-size: 36px;
    `};
    ${props => props.theme.media.giant`
      font-size: 45px;
    `};
  }

`;

export const TitleWrap = styled.div`
  color: #fff;
  position: relative;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin: 10px 0;
  }
`;

export const EditLink = styled(Link)`
  border: 4px dashed rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${props => props.theme.colors.white};
  text-decoration: none;
  position: relative;
  z-index: 1;
  height: 190px;
  width: calc(100% - ${props => props.theme.gutter});
  max-width: 600px;
  margin: auto 0 0.6em;
  text-align: center;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .story-detail-header__title-and-dates {
    margin: auto;
  }
`;

export const IconWrap = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background: ${props => props.theme.colors.white};
  border-radius: 50%;
  font-size: 20px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-left: 3px;
  }
`;

export const Wrap = styled.div`
  width: 100%;
`;

export const EditHeader = styled.div`
  display: flex;
  width: 100%;
  position: fixed;
  top: 60px;
  transition: 0.3s ease all;
  margin-left: auto;
  z-index: 999;
  padding: 8px;
  ${color};

  ${props => props.theme.media.desktop`
width: calc(100vw - 270px);
  `}
`;

export const MoveHeaderWrap = styled.div``;
